import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useAsignaturas } from "../../../../context/SuperAdmin/OASContexts/AsignaturasContext";
import { AsignaturaFields } from "../../../../interfaces/SuperAdmin/Pages/iDataAsignatura";
const EditAsignaturaModal = () => {
  const {
    isEditModalOpen,
    toggleEditModal,
    toEditAsignatura,
    asignaturaEdit,
    isEditing,
  } = useAsignaturas();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<AsignaturaFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: AsignaturaFields) => {
    if (toEditAsignatura) {
      asignaturaEdit(data, toEditAsignatura.id_asignatura);
    }
  };

  const handleClose = () => {
    if (!isEditing) {
      reset();
      toggleEditModal(false);
    }
  };

  useEffect(() => {
    if (toEditAsignatura) {
      reset({
        nombre: toEditAsignatura.nombre,
      });
    }
  }, [toEditAsignatura]);

  return (
    <Modal
      open={isEditModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Editar asignatura
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombre
          </Typography>
          <Controller
            name="nombre"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre?.message}
                disabled={isEditing}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditing}
            type="submit"
          >
            {isEditing ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditAsignaturaModal;
